import { HttpErrorResponse } from '@angular/common/http';
import {LoginRequest} from '../../../models/auth.model';

const ACTION_SCOPE = '[Auth]';

const createType = (_class: { name: string}): string => {
  return `[${ACTION_SCOPE}] ${_class.name}`;
}

export class Login {
  static readonly type = createType(this);
  constructor(public payload: LoginRequest) {}
}

export class SetTokens {
  static readonly type = createType(this);
  constructor(public accessToken: string) {}
}

export class Logout {
  static readonly type = createType(this);
}

export class ApiError {
  static readonly type = createType(this);
  constructor(public error?: HttpErrorResponse | string) {}
}
